import { render } from "./ddd.vue?vue&type=template&id=4e1f19ed"
import script from "./ddd.vue?vue&type=script&lang=js"
export * from "./ddd.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__